/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';

// Actions
import { setClose } from 'store/ducks/dialogs/actions';

// Styles
import useStyles from './dialogRedux.styles';

function DialogRedux() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const dialog = useSelector(
    (state: any) =>
      state.dialogs.dialog || {
        open: false,
        content: null,
        propsDialog: null,
        disableBackdropClick: false,
        disableContentPadding: false,
        onClose: undefined,
        maxWidth: undefined,
      },
  );

  const handleClose = () => {
    dispatch(setClose());
    if (dialog.onClose) {
      dialog.onClose();
    }
  };

  return (
    <Dialog
      open={dialog.open}
      maxWidth={dialog.maxWidth}
      className={
        dialog.content
          ? `${classes.root} ${
              dialog.disableContentPadding ? classes.noPaperPadding : ''
            }`
          : undefined
      }
      onClose={dialog.disableBackdropClick ? () => {} : () => handleClose()}>
      <DialogContent
        className={
          dialog.disableContentPadding ? classes.noPadding : undefined
        }>
        {dialog.content && !React.isValidElement(dialog.content) && (
          <dialog.content {...dialog.propsDialog} />
        )}
        {dialog.content &&
          React.isValidElement(dialog.content) &&
          React.cloneElement(dialog.content, dialog.propsDialog)}
      </DialogContent>
    </Dialog>
  );
}

export default DialogRedux;
export { DialogRedux };
